export const Token = data => {
    window.localStorage.setItem('token', data.token);
};
